import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FilterVideo, Label, VideoDetail, VideoEdit, VideoEditSalida } from 'src/app/models/video';
import { ApiService } from 'src/app/services/api.service';
import { LogsService } from 'src/app/services/logs.service';
import {environment} from "../../../environments/environment";
import videojs from 'video.js';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component'
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-edit',
  templateUrl: './edit.component.html',
  styleUrls: ['./edit.component.scss']
})
export class EditComponent implements OnInit {

  date = new Date();

  token = ''
  breadcrumbs = []
  videoId:string = ''
  data_tag: Label = {
    EtiquetaCod: 0,
    FechaRegistro: '',
    GrabacionCod: '0',
    Nombre: ''
  }
  video: VideoDetail = {
    CiudadCodAudiencia: "",
    EntidadCodAudiencia: "",
    EspecialidadCodAudiencia: "",
    Estado: "",
    Etiquetas: [],
    FechaGrabacion: "",
    FechaRegistro: "",
    GrabacionCod: 0,
    HoraGrabacion: "",
    JuzgadoCodAudiencia: "",
    JuzgadoNombre: "",
    NombreArchivo: "",
    NombreSala: "",
    NumeroGrabacion: "",
    OrigenGrabacion: "",
    ProcesoCod: "",
    RutaDecodificado: "",
    RutaOriginal: "",
    TipoAudiencia: "",
    VideosCompartidos: [],
    Adjuntos: [],
    VideoCompartidoUsuarios: [],
    DistritoCod: '',
    DistritoNombre: '',
    AreaCod: '',
    AreaNombre: '',
    JurisdiccionCod: '',
    JurisdiccionNombre: '',
    NombreJuez: '',
    TiempoEtiquetas: [],
    CaracterReservado: true,
    Duracion: '',
    EtiquetasLista: ''
  }
  options = {
    autoplay: false,
    controls: true,
    preload: 'metadata',
    sources: [
      {
        src: '',
        type: 'video/mp4',
        poster: ''
      }
    ]
  };
  poster:string = ''
  player: videojs.Player;
  module = "Edición"
  @ViewChild('idVideo', {static: true}) idVideo: ElementRef;
  ProcedureValue:any = {}
  formCreate: FormGroup;
  filterVideo: FilterVideo = {
    usePagination: true,
    orderField: 'FechaGrabacion',
    orderDirection: 'DESC',
    pageRecords: 10,
    pageIndex: '1',
    general: '',
    juzgadoCodList: 'ALL',
    useDateFilter: '1',
    lowerDate: '',
    upperDate: '',
    intervinienteNombre: '',
    procesoCod: '',
    etiqueta: '',
    district: '-1',
    area: '-1'
  }
  videoEdit: VideoEdit = {
    JuzgadoCod: "",
    YearRadicado: "",
    NumeroProceso: "",
    Consecutivo: "",
    TipoAudiencia: "",
    ProcesoCod: "",
    NombreSala: "",
    NumeroGrabacion: "",
    FechaGrabacion: "",
    HoraGrabacion: "",
    OrigenGrabacion: "",
    Juez: "",
    GrabacionCod: 0,
    NombreArchivo: '',
    CaracterReservado: false,
    JuzgadoProcesoCod: ''
  }
  videoOriginalProperties: VideoEdit = {
    JuzgadoCod: '',
    YearRadicado: '',
    NumeroProceso: '',
    Consecutivo: '',
    TipoAudiencia: '',
    ProcesoCod: '',
    NombreSala: '',
    NumeroGrabacion: '',
    FechaGrabacion: '',
    HoraGrabacion: '',
    OrigenGrabacion: '',
    Juez: '',
    GrabacionCod: 0,
    NombreArchivo: '',
    CaracterReservado: false,
    JuzgadoProcesoCod: ''
  }

  TIPOSAUDIENCIA = ["R","L"];
  ORIGENESGRABACION = ["P","V"];
  user_id: string;

  isStream:boolean;

  isLoading:boolean = true;


  constructor(private activeRoute: ActivatedRoute,
              public apiService: ApiService,
              private router: Router,
              public logService: LogsService,
              private formBuilder: FormBuilder,
              private _snackBar: MatSnackBar,
              public dialog: MatDialog) { }

  ngOnInit(): void {
    this.token = localStorage.getItem('token')
    this.user_id = localStorage.getItem('user_id');
    if(this.user_id != null)
    {
      this.ProcedureValue = JSON.parse(localStorage.getItem('data_user'))

      this.activeRoute.params.subscribe(params => {

        this.videoId = params.id;
        this.data_tag.GrabacionCod = this.videoId

        if(this.ProcedureValue.type == 'scheduler'){
          this.router.navigate([`/detail/${this.videoId}`])
        }

        this.GetVideoDetail()


        let formT = localStorage.getItem('formTransliterator')
        if (formT == null){
          this.breadcrumbs = [
            {name: 'Inicio', url: '/'+this.token+'/'+localStorage.getItem('user_id')},
            //{name: 'Inicio', url: '/'+localStorage.getItem('user_id')},
            {name: 'Detalle del video', url: '/detail/'+ this.videoId},
            {name: 'Editar', url: '/edit/'+ this.videoId}
          ]
        }else{
          this.breadcrumbs = [
            {name: 'Inicio', url: '/'+this.token+'/'+localStorage.getItem('user_id')},
            //{name: 'Inicio', url: '/'+localStorage.getItem('user_id')},
            {name: 'Búsqueda por transliteración', url: '/transliterator'},
            {name: 'Detalle del video', url: '/detail/'+ this.videoId},
            {name: 'Editar', url: '/edit/'+ this.videoId}
          ]
        }

      })

      /* this.formCreate = this.formBuilder.group({
        JuzgadoCod: ['', {validators: [Validators.required,Validators.maxLength(12),Validators.minLength(12)]}],
        JuzgadoProcesoCod: ['', {validators: [Validators.required,Validators.maxLength(12),Validators.minLength(12)]}],
        YearRadicado: ['', {validators: [Validators.required,Validators.max(this.date.getFullYear()),Validators.min(1990)]}],
        NumeroProceso: ['', {validators: [Validators.required,Validators.maxLength(5),Validators.minLength(5)]}],
        Consecutivo: ['', {validators: [Validators.required,Validators.maxLength(2),Validators.minLength(2)]}],
        TipoAudiencia: ['', {validators: [Validators.required]}],
        NombreSala: ['', {validators: [Validators.required,Validators.maxLength(10),Validators.minLength(10)]}],
        NumeroGrabacion: ['', {validators: [Validators.required,Validators.maxLength(2),Validators.minLength(2)]}],
        FechaGrabacion: ['', {validators: [Validators.required]}],
        HoraGrabacion: ['', {validators: [Validators.required]}],
        OrigenGrabacion: ['', {validators: [Validators.required]}],
        Juez: ['', {validators: [Validators.required]}],
      }) */

    }
    else
      this.exit()

  }

  formatDate(fecha:string):string{
    let formatedDate: string = '';
    let year: string = fecha.split('/')[2];
    let day: string = fecha.split('/')[0].length<2?`0${fecha.split('/')[0]}`:fecha.split('/')[0];
    let month: string = fecha.split('/')[1].length<2?`0${fecha.split('/')[1]}`:fecha.split('/')[1];;

    formatedDate =`${year}-${month}-${day.length<2?'0':''}${day}`;

    return formatedDate;
  }

  reverseFormDate(fecha:string):string{

    let formatedDate: string = '';
    let year: string = fecha.split('-')[0];
    let month: string = fecha.split('-')[1];
    let day: string = fecha.split('-')[2];

    formatedDate =`${year}${month}${day}`;

    return formatedDate;
  }

  reverseFormDateOutput(fecha:string):string{

    let formatedDate: string = '';

    let year: string = fecha.split('-')[0];

    let day: string = fecha.split('-')[2];

    let month: string = fecha.split('-')[1];


    formatedDate =`${year}-${month}-${day}`;

    return formatedDate;
  }

  GetVideoDetail(): void{
    this.apiService.GetInfoVideo(this.videoId,localStorage.getItem('user_id')).subscribe(
      request=>{
        if(request.GrabacionCod == -1) this.exit()
        this.video = <VideoDetail> request;
        console.log(request);
        const year = parseInt(request.ProcesoCod.slice(request.ProcesoCod.length-11, 16), 10);
        console.log(year);
        this.isStream = !(!isNaN(year) && year > 1990 && year <= new Date().getFullYear());
        //this.isStream = true
        if(this.isStream){
          this.videoEdit = {
            JuzgadoProcesoCod: request.ProcesoCod,
            YearRadicado: "",
            NumeroProceso: "",
            Consecutivo: "",
            TipoAudiencia: request.TipoAudiencia,
            ProcesoCod: request.ProcesoCod,
            NombreSala: request.NombreSala,
            NumeroGrabacion: request.NumeroGrabacion.toString().padStart(2, '0'),
            FechaGrabacion: this.formatDate(request.FechaGrabacion),
            HoraGrabacion: this.getHour(request.HoraGrabacion),
            OrigenGrabacion: request.OrigenGrabacion,
            Juez: request.NombreJuez,
            GrabacionCod: request.GrabacionCod,
            CaracterReservado: request.CaracterReservado,
            NombreArchivo: request.NombreArchivo,
            JuzgadoCod: request.NombreArchivo.split('_')[1].slice(1,13),
          };
          this.formCreate = this.formBuilder.group({
            JuzgadoCod: ['', {validators: [Validators.required,Validators.maxLength(12),Validators.minLength(12)]}],
            JuzgadoProcesoCod: ['', {validators: [Validators.required,Validators.maxLength(50),Validators.minLength(23)]}],
            TipoAudiencia: ['', {validators: [Validators.required]}],
            NombreSala: ['', {validators: [Validators.required,Validators.maxLength(10),Validators.minLength(10)]}],
            NumeroGrabacion: ['', {validators: [Validators.required,Validators.maxLength(2),Validators.minLength(2)]}],
            FechaGrabacion: ['', {validators: [Validators.required]}],
            HoraGrabacion: ['', {validators: [Validators.required]}],
            OrigenGrabacion: ['', {validators: [Validators.required]}],
            Juez: ['', {validators: [Validators.required]}],
          })
        }
        else{
          this.videoEdit = {
            YearRadicado: request.ProcesoCod.slice(12,16),
            NumeroProceso: request.ProcesoCod.slice(16,21),
            Consecutivo: request.ProcesoCod.slice(21,23),
            TipoAudiencia: request.TipoAudiencia,
            ProcesoCod: request.ProcesoCod,
            NombreSala: request.NombreSala,
            NumeroGrabacion: request.NumeroGrabacion.toString().padStart(2, '0'),
            FechaGrabacion: this.formatDate(request.FechaGrabacion),
            HoraGrabacion: this.getHour(request.HoraGrabacion),
            OrigenGrabacion: request.OrigenGrabacion,
            Juez: request.NombreJuez,
            GrabacionCod: request.GrabacionCod,
            CaracterReservado: request.CaracterReservado,
            NombreArchivo: request.NombreArchivo,
            JuzgadoCod: request.NombreArchivo.split('_')[1].slice(1,13),
            JuzgadoProcesoCod: request.ProcesoCod.slice(0,12),
          };
          this.formCreate = this.formBuilder.group({
            JuzgadoCod: ['', {validators: [Validators.required,Validators.maxLength(12),Validators.minLength(12)]}],
            JuzgadoProcesoCod: ['', {validators: [Validators.required,Validators.maxLength(12),Validators.minLength(12)]}],
            YearRadicado: ['', {validators: [Validators.required,Validators.max(this.date.getFullYear()),Validators.min(1990)]}],
            NumeroProceso: ['', {validators: [Validators.required,Validators.maxLength(5),Validators.minLength(5)]}],
            Consecutivo: ['', {validators: [Validators.required,Validators.maxLength(2),Validators.minLength(2)]}],
            TipoAudiencia: ['', {validators: [Validators.required]}],
            NombreSala: ['', {validators: [Validators.required,Validators.maxLength(10),Validators.minLength(10)]}],
            NumeroGrabacion: ['', {validators: [Validators.required,Validators.maxLength(2),Validators.minLength(2)]}],
            FechaGrabacion: ['', {validators: [Validators.required]}],
            HoraGrabacion: ['', {validators: [Validators.required]}],
            OrigenGrabacion: ['', {validators: [Validators.required]}],
            Juez: ['', {validators: [Validators.required]}],
          })
        }
        this.videoOriginalProperties = {...this.videoEdit};
        console.log(this.videoEdit);
        let src_video = environment.urlApiVideos.url+'/api/filevideo/descargar?videoName='+this.video.NombreArchivo+"&UserID="+this.user_id
        this.options.sources[0].src = src_video;
        const type = this.video.NombreArchivo.split('.')[1]
        if(type === 'mp3'){
          this.options.sources[0].type = 'audio/mp3'
          this.poster = '../../../assets/poster.jpg'
        }else{
          this.options.sources[0].type = 'video/mp4'
          this.poster = ''
        }
        this.player = videojs(this.idVideo.nativeElement, this.options, function onPlayerReady() {
          console.log('onPlayerReady', this);
        })
        this.player.on('error', () => {
          console.log(this.player.error());
          if(this.player.error().code == 4){
            console.log('error 4');
            this.logService.createLogErrorDireccion(`No se encuentra grabación`,this.video.GrabacionCod,this.video.RutaDecodificado,this.video['Almacenamiento'],4).subscribe({
              next:res=>{
                console.log(res);
              },
              error:err=>console.error(err)
            })

          }
          if(this.player.error().code == 3) console.log('error 3');
        });
        this.logService.createLog(this.module,
          "visualización del video " +this.video.NombreArchivo).subscribe(
          request =>console.log("ok"),
          error => console.error(error)
        )
        this.ProcedureValue = JSON.parse(localStorage.getItem('data_user'))
        Object.keys(this.formCreate.controls).forEach(controlName => {
          this.formCreate.controls[controlName].updateValueAndValidity();
        });
        this.isLoading=false;
      },
      error => {

      }
    )
  }

  exit(): void{
    this.router.navigate(['/'])
  }

  showModalEditConfirm():void{

    let videoSendNames: any = {
      JuzgadoProcesoCod:"",
      YearRadicado:"",
      NumeroProceso:"",
      Consecutivo:"",
      GrabacionCod: "",
      ProcesoCod: '',
      NombreArchivo: '',
      TipoAudiencia: 'Tipo audiencia',
      JuzgadoCod: 'Juzgado',
      NombreSala: 'Nombre sala',
      NumeroGrabacion: 'número de grabación',
      FechaGrabacion: 'Fecha Grabación',
      HoraGrabacion: 'Hora Grabación',
      OrigenGrabacion: 'Origen Grabación',
      CaracterReservado: "",
      Juez: 'Juez'
    };

    console.log('cambios');
    console.log(this.videoOriginalProperties);
    console.log(EditComponent);

    if (!Object.keys(videoSendNames).every(propertie => this.videoOriginalProperties[propertie] === this.videoEdit[propertie])) {
      const dialogRef = this.dialog.open(ConfirmDialogComponent, {
        width: '500px',
        data: {'title': 'Alerta:',
          'subtitle': '¿Está seguro de actualizar los datos?'}
      });
      dialogRef.afterClosed().subscribe(
        res=>{
          if(res){
            this.CreateTag();
          }
        });
    }



  }

  areChanges(){

    let videoSendNames: any = {
      JuzgadoProcesoCod:"",
      YearRadicado:"",
      NumeroProceso:"",
      Consecutivo:"",
      GrabacionCod: "",
      ProcesoCod: '',
      NombreArchivo: '',
      TipoAudiencia: 'Tipo audiencia',
      JuzgadoCod: 'Juzgado',
      NombreSala: 'Nombre sala',
      NumeroGrabacion: 'número de grabación',
      FechaGrabacion: 'Fecha Grabación',
      HoraGrabacion: 'Hora Grabación',
      OrigenGrabacion: 'Origen Grabación',
      CaracterReservado: "",
      Juez: 'Juez'
    };

    return Object.keys(videoSendNames).every(propertie =>{
      return this.videoOriginalProperties[propertie] === this.videoEdit[propertie]
    })
  }

  CreateTag():void{
    console.log(this.formCreate.invalid);
    this.videoEdit.ProcesoCod = this.videoEdit.JuzgadoProcesoCod + this.videoEdit.YearRadicado + this.videoEdit.NumeroProceso + this.videoEdit.Consecutivo;
    let ext = this.videoEdit.NombreArchivo.split('.')[this.videoEdit.NombreArchivo.split('.').length-1];
    let nombreArchivo_1 = this.videoEdit.ProcesoCod;
    let nombreArchivo_2 = this.videoEdit.TipoAudiencia+this.videoEdit.JuzgadoCod+this.videoEdit.NombreSala;
    let nombreArchivo_3 = this.videoEdit.NumeroGrabacion+"_"+
                          this.reverseFormDate(this.videoEdit.FechaGrabacion)+
                          "_"+this.reverseHour(this.videoEdit.HoraGrabacion)+
                          "_"+this.videoEdit.OrigenGrabacion;

    this.videoEdit.NombreArchivo =  nombreArchivo_1+'_'+nombreArchivo_2+'_'+nombreArchivo_3+'.'+ext;

    let videoEditSend = {
      ...this.videoEdit,
      FechaGrabacion: this.reverseFormDateOutput(this.videoEdit.FechaGrabacion),
      HoraGrabacion: this.reverseHour(this.videoEdit.HoraGrabacion)
    }

    let videoSend: VideoEditSalida={
      GrabacionCod: 0,
      ProcesoCod: '',
      NombreArchivo: '',
      TipoAudiencia: '',
      JuzgadoCod: '',
      NombreSala: '',
      NumeroGrabacion: '',
      FechaGrabacion: '',
      HoraGrabacion: '',
      OrigenGrabacion: '',
      CaracterReservado: false,
      Juez: ''
    };

    for(let properties of Object.keys(videoSend)){
      videoSend[properties] = videoEditSend [properties];
    }

    videoSend['CaracterReservado'] = videoSend['TipoAudiencia']=="R"

    console.log('videdo send:',videoSend);

    if(Object.keys(videoSend).every(key=>this.videoOriginalProperties[key]==this.videoEdit[key])) return


    this.apiService.updateVideoData(videoSend).subscribe({
      next: res => {
        if(parseInt(res)>0){
          this._snackBar.open('Datos actualizados con éxito.','cerrar',{duration:6000});
          this.videoOriginalProperties = {...this.videoEdit};
        }
      },
      error: err => console.log(err)
    })

    //logica logs
    for(let properties of Object.keys(videoSend)){
      if(this.videoOriginalProperties[properties]!=this.videoEdit[properties]){

        let original = this.videoOriginalProperties[properties];
        let edi = this.videoEdit[properties];

        let logEvento = "";

        let TipoLogEventoId = 0;

        let description = "";


        if( properties=='NumeroGrabacion'||
            properties=='OrigenGrabacion'||
            properties=='FechaGrabacion' ||
            properties=='HoraGrabacion'){

          logEvento = 'la Info. de la grabación';
          TipoLogEventoId = 3;

          if(properties == 'FechaGrabacion'){
            original = this.reverseFormDateOutput(original)
            edi = this.reverseFormDateOutput(edi)
          }
          else if(properties == 'HoraGrabacion'){
            original = this.reverseHour(original);
            edi = this.reverseHour(edi);
          }

        }
        else if(properties=='Juez'){
          logEvento = 'Juez'
          TipoLogEventoId = 4;
        }
        else if(properties=='ProcesoCod'){
          logEvento = 'la Info. del proceso'
          TipoLogEventoId = 1;
        }
        else if(properties=='TipoAudiencia'||properties=='NombreSala'||properties=='JuzgadoCod'){
          logEvento = 'la Info. de la audiencia'
          TipoLogEventoId = 2
        }
        else if(properties=='NombreArchivo'){

          /* TipoLogEventoId = 6;
          logEvento = 'el Nombre del Archivo adjunto de la grabación'

          this.video.Adjuntos.forEach(adj=>{
            description = 'Al archivo '+videoSend.NombreArchivo+' se cambió sobre '+logEvento+' la propiedad NombreArchivoAdjunto antes era: '+ original +' y ahora es: '+ edi
            console.log(description);
            this.logService.createLog(this.module,description,TipoLogEventoId,videoSend.GrabacionCod,adj.AdjuntoCod).subscribe({
              next: res=>console.log(res),
            });
          }) */

          TipoLogEventoId = 5;
          logEvento = 'el Nombre del Archivo de la grabación'

        }

        description = 'Al archivo '+videoSend.NombreArchivo+' se cambió sobre '+logEvento+' la propiedad '+properties+' antes era: '+ original +' y ahora es: '+ edi

        console.log(description);

        this.logService.createLog(this.module,description,TipoLogEventoId,videoSend.GrabacionCod).subscribe({
          next: res=>console.log(res),
        });

      }

    }

    /*
      edicion_info_del_proceso: 1,
      edicion_info_de_la_audiencia: 2,
      edicion_info_de_grabacion: 3,
      edicion_del_juez: 4,
      edicion_nombre_archivo: 5,
      edicion_nombre_archivo_adjunto: 6
    */


  }

  getHour(hora: string): string {
    let splitHour = hora[0]+hora[1]
    let splitMin = hora[2]+hora[3]

    return `${splitHour}:${splitMin}`;
  }

  reverseHour(hour:string):string{
    return `${hour.replace(':','')}00`;
  }

  checkLength(event: any, name: string, maxLength: number): void {
    let value = event != null ? event.toString() : "";  // Convertir a string
    if (value.length > maxLength) {
      value = value.substring(0, maxLength);
    }

    const formControl = this.formCreate.get(name);

    // Verificar si el valor actual es diferente antes de asignarlo
    if (formControl.value !== value) {
      formControl.setValue(value, { emitEvent: false });  // Evitar disparar otro evento de cambio
    }

    this.videoEdit[name] = value;  // Asignar siempre como string
  }

  onYearRadicadoChange(event: any): void {
    this.checkLength(event, 'YearRadicado', 4);
  }

  onlyNumberKey(event: KeyboardEvent) {
    if (!/^\d$/.test(event.key)) event.preventDefault();
  }

  onlyAlphabeticalKey(event: KeyboardEvent) {
    if(!/^[a-zA-Z\sáéíóúÁÉÍÓÚüÜ]$/.test(event.key)) event.preventDefault();
  }

  onlyAlphanumericKey(event: KeyboardEvent) {
    if (!/^[a-zA-Z0-9\sáéíóúÁÉÍÓÚüÜ]$/.test(event.key)) event.preventDefault();
  }



}
